import { DialogForm, Form } from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { useGetShareGroups } from '@ais-ui/websockets';
import { SendMessageForm } from './SendMessageForm';
import { SendMessageFormValues } from './sendMessageForm';

interface SendMessageDialogProps {
  form: UseFormReturn<SendMessageFormValues>;
  onSubmit: (data: SendMessageFormValues) => void;
  isSubmitting: boolean;
  setShowOuterDialog: (showOuterDialog: boolean) => void;
}

export const SendMessageDialog = ({
  form,
  onSubmit,
  isSubmitting,
  setShowOuterDialog,
}: SendMessageDialogProps) => {
  const { messages } = useLocalization();
  const [showDialog] = useState<boolean>(true);
  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={setShowOuterDialog}
        title="Send message"
        isLoading={isLoadingGroups}
        hasLoaded={!isLoadingGroups && !!groups}
        buttonId="submit-send-message-button"
        buttonText={
          isSubmitting ? messages.genericSubmitting : messages.genericSubmit
        }
        buttonDisabled={isSubmitting}
        buttonOnClick={form.handleSubmit(onSubmit)}
      >
        <SendMessageForm form={form}></SendMessageForm>
      </DialogForm>
    </Form>
  );
};
